import { styledWithTheme } from "../../../../styles/theme";
import { SemanticButtonCP } from "../../../../helpers/ReactHelpers";

// TODO: [LAT-457] SimpleButton: Primary button has to be the same size as action button. And make it bigger.
export const BaseButton = styledWithTheme(SemanticButtonCP)<{
  initialpadding?: 0 | 1;
}>(({ initialpadding, theme }) => ({
  "&&&": {
    ...theme.typography.button1,
    padding: initialpadding ? undefined : ".62em 1.2em .62em",
    backgroundColor: theme.palette.mono.base,
    color: theme.palette.mono.black,
    borderRadius: "0.289em",
    margin: "0 .25em 0 0",
    "&:hover": {
      backgroundColor: theme.palette.mono.black,
      borderColor: theme.palette.mono.black,
      color: theme.palette.mono.white,
    },
  },
}));

export const MinimalActionButton = styledWithTheme(BaseButton)`
  &&& {
    margin: 0;
    background-color: ${({ theme }) => theme.palette.mono.white};
  }
  `;

export const ActionButton = styledWithTheme(BaseButton)`
  &&& {
    background-color: ${({ theme }) => theme.palette.mono.white};
    border: solid 1px ${({ theme }) => theme.palette.mono.black};
  }
`;

export const MiniButton = styledWithTheme(BaseButton)(({ theme }) => ({
  "&&&": {
    ...theme.typography.button3,
    backgroundColor: theme.palette.mono.white,
    border: `solid 1px ${theme.palette.mono.black}`,
  },
}));

export const SocialButton = styledWithTheme(MinimalActionButton)`
  &&& {
    height: 45px;
    width: 100%;
    padding:  0 0.2em 0 0.2em;
    margin: auto;
    color: ${({ theme }) => theme.palette.mono.darker};
    border: solid 1px ${({ theme }) => theme.palette.mono.darker}
  }
`;

export const PrimaryButton = styledWithTheme(BaseButton)(({ theme }) => ({
  "&&&": {
    ...theme.typography.button2,
    backgroundColor: theme.palette.primary.main,
    ".icon": {
      marginRight: "0.25em !important",
    },
  },
}));

export const BasicButton = styledWithTheme(BaseButton)(({ theme }) => ({
  "&&&": {
    ...theme.typography.basicButton,
    backgroundColor: "inherit",
    ":hover": {
      backgroundColor: "transparent",
      borderColor: theme.palette.mono.black,
      color: theme.palette.mono.darker,
    },
  },
}));

export const FooterButton = styledWithTheme(BaseButton)(({ theme }) => ({
  "&&&": {
    ...theme.typography.basicButton,
    color: theme.palette.mono.light,
    backgroundColor: "inherit",
    padding: "0.2 em",
    margin: "0.2 em",
  },
}));
